import React from "react";
import { ContractType } from "../../../redux/slices/my-account/Types";
import { useAppSelector } from "../../../redux";
import useProductListPageRoute from "../../../hooks/useProductListPageRoute";
import moment from "moment";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  InlineStatus,
  InlineStatusAppearance,
  InlineStatusIconType,
} from "@hid-galaxy-ui/galaxy-react";
import ServiceContractDetailModal from "../ServiceContractDetailModal";
import "./ContractCard.scss";

const ContractCard: React.FC<{
  contract: ContractType;
  gap?: number;
}> = ({ contract, gap }) => {
  const [detailModalOpen, setDetailModalOpen] = React.useState<boolean>(false);
  const { collection } = useAppSelector((state) => state.plp);
  const { getRouteIndex } = useProductListPageRoute();
  const shopifyNavigationHandle = "service-catalog";
  const subCollection = collection[getRouteIndex(shopifyNavigationHandle)];
  const sortedCollection = React.useMemo(() => subCollection, [collection]);
  const allProducts = sortedCollection
    .map((col) => {
      return col.products.nodes;
    })
    .flat();
  const active: boolean =
    moment(contract.end_date).startOf("day") >= moment().startOf("day");
  const subscription = contract.subscription_id ? true : false;
  const dateBoolean = subscription && contract.subscription_status === "active";

  // const isProductAvailable =
  //   allProducts.filter(
  //     (product: any) => product.variants.edges[0].node.sku === contract.sku
  //   ).length > 0;

  const contractStatus = (status: string) => {
    if (status === "Active") {
      return (
        <InlineStatus
          label="Active"
          appearance={InlineStatusAppearance.Positive}
          iconType={InlineStatusIconType.Dot}
        />
      );
    } else if (status === "Scheduled") {
      return (
        <InlineStatus
          label="Scheduled"
          appearance={InlineStatusAppearance.Caution}
          iconType={InlineStatusIconType.Dot}
        />
      );
    } else {
      return (
        <InlineStatus
          label={status}
          appearance={InlineStatusAppearance.Danger}
          iconType={InlineStatusIconType.Dot}
        />
      );
    }
  };

  return (
    <>
      <div className="contract-card" key={contract.ID}>
        <div className="info" style={gap ? { gap: `${gap}px` } : {}}>
          <div className="label-value">
            <div className="label">Status</div>
            <div className="status-value">{contractStatus(contract.status)}</div>
          </div>
          <div className="label-value">
            <div className="label">Start Date</div>
            <div className="value">
              {moment(contract.start_date)?.format("DD-MMM-yyyy")}
            </div>
          </div>
          <div className="label-value">
            <div className="label">
              {dateBoolean ? "Renewal Date" : "Expiry Date"}
            </div>
            <div className="value">
              {dateBoolean
                ? moment(contract.end_date)
                    .add(1, "d")
                    .format("DD-MMM-YYYY")
                : moment(contract.end_date).format("DD-MMM-YYYY")}
            </div>
          </div>
          <div className="label-value">
            <div className="label">Work Package Type</div>
            <div className="value">{contract.contract_name}</div>
          </div>
        </div>
        <div className="button-group">
          <Button
            variant="secondary"
            icon={
              <Iconography
                icon="ellipsisVertical"
                size={IconographySizes.Default}
              />
            }
            onClick={() => {
              setDetailModalOpen(true);
            }}
          />
        </div>
      </div>
      {detailModalOpen && (
        <ServiceContractDetailModal
          serviceContractDetail={contract}
          setDetailModalOpen={setDetailModalOpen}
        />
      )}
    </>
  );
};

export default ContractCard;
